<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="9"
        align-self="center"
      >
        <div
          class="primary--text text-h5 my-2"
        >
          {{ $t('course_report.title') }}
        </div>
      </v-col>
      <div>
        <v-col>{{ $t('course_report.page_intro') }}</v-col>
        <v-col v-html="$t('course_report.page_instruction')" />
      </div>
      <v-col
        cols="12"
      >
        <seminar-list-section
          :headers="headers"
          :seminars="seminarAttendances"
          :loading="loading"
          :soft-loading="softLoading"
        />
      </v-col>
      <v-col
        class="mb-4"
        v-html="$t('course_report.attendee_table_note')"
      />
    </v-row>
    <v-row>
      <v-col
        v-if="$vuetify.breakpoint.smAndUp"
        cols="12"
      >
        <v-btn
          v-for="(seminar, index) in seminarAttendances"
          :key="`${index}-${seminar.id}`"
          :color="tab === seminar.id ? 'primary' : ''"
          class="mt-2 mr-2"
          rounded
          @click="setQuestionnaireData(seminar.id)"
        >
          {{ seminar.seminar }}
        </v-btn>
      </v-col>
      <v-col
        v-else
        cols="12"
      >
        <v-select
          v-model="tab"
          outlined
          color="primary"
          label="seminar type"
          :items="seminarAttendances"
          item-value="id"
          item-text="seminar"
          small-chips
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-skeleton-loader
          v-if="loading"
          type="card"
        />
        <questionnaire-section
          v-else
          :flag="0"
          :questionnaires="seminarQuestionnaires?.find(x => x.report_division_id === 0)"
          :static-questionnaires="seminarStaticQuestionnaires?.find(x => x.report_division_id === 0)?.question"
          :soft-loading="softLoading"
          @update="updateOriginalQuestion($event)"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-skeleton-loader
          v-if="loading"
          type="card"
        />
        <questionnaire-section
          v-else
          :questionnaires="seminarQuestionnaires?.find(x => x.report_division_id === 1)"
          :static-questionnaires="seminarStaticQuestionnaires?.find(x => x.report_division_id === 1)?.question"
          :flag="1"
          :soft-loading="softLoading"
          @update="updateOriginalQuestion($event)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SeminarListSection from './SeminarListSection.vue'
import QuestionnaireSection from './QuestionnaireSection.vue'
import QUATSError from '../../../plugins/error'

export default {
  components: {QuestionnaireSection, SeminarListSection},
  data () {
    return {
      attendances: [],
      loading: true,
      softLoading: false,
      tab: 1,
      selectSeminars: [],
      questionnaires: [],
      staticQuestionnaires: [],
      selectStaticQuestionnaire: []
    }
  },

  computed: {
    seminarAttendances() {
      return this.attendances
    },

    seminarQuestionnaires() {
      return this.selectSeminars
    },

    seminarStaticQuestionnaires() {
      return this.selectStaticQuestionnaire.questionnaires
    },

    headers() {
      return [
        { text: '', value: 'data-table-expand', sortable: false, class: 'primary white--text'},
        { text: 'セミナー', value: 'seminar', sortable: false, class: 'primary white--text'},
        { text: this.$vuetify.breakpoint.xs ? this.$t('course_report.send_mail') : '', value: 'mail', sortable: false, class: 'primary white--text', width: '80px'},
        { text: 'レポート提出', value: 'report', sortable: false, class: 'primary white--text', width: '120px'},
      ]
    },
  },

  created() {
    this.fetchEmployeeAttendantList()
  },

  methods: {
    async updateLoadingStates() {
      this.softLoading = true
      await this.fetchEmployeeAttendantList()
      this.softLoading = false
    },

    async updateOriginalQuestion(data) {
      this.softLoading = true
      try {
        await window.axios.patch('/api/employee-course-report/course/report/questionnaire', data)
        await this.updateLoadingStates()
      } catch (err) {
        this.handleError(err)
      }
    },

    setQuestionnaireData(id) {
      this.tab = id
      this.selectSeminars = this.questionnaires.filter(x => x.seminar_division_id === id)
      this.selectStaticQuestionnaire = this.staticQuestionnaires.find(x => x.seminar_division_id === id)
    },

    async fetchEmployeeAttendantList() {
      try {
        const results = await Promise.all([
          window.axios.get('/api/employee-course-report/course/report/attendant'),
          window.axios.get('/api/employee-course-report/course/report/questionnaire'),
          window.axios.get('/api/employee-course-report/course/report/static/questionnaire')
        ])

        const attendances = results[0].data.data.data
        this.questionnaires = results[1].data.data.data
        this.staticQuestionnaires = results[2].data
        this.manipulateAttendantData(attendances, this.questionnaires)
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },

    handleError(err) {
      this.$store.commit('snackbar/errorSnackbar', [new QUATSError(this.$i18n, err).message])
    },

    manipulateAttendantData(histories, questionnaires) {
      const seminarDivisions = [1, 2, 3, 4]
      const attendances = []
      seminarDivisions.forEach(seminarDivision => {
        const attendees = histories[`seminar_division_${seminarDivision}`]
        attendees.map(attendee => {
          const { start_date, end_date, place, questionnaire_contents } = attendee
          attendee['display'] = `${this.seminarDateRangeDisplay(start_date, end_date)} (${place})`
          attendee['pre'] = questionnaire_contents?.length > 0 && questionnaire_contents?.some(question => question.fc_flg === 0)
          attendee['post'] = questionnaire_contents?.length > 0 && questionnaire_contents?.some(question => question.fc_flg === 1)
          return attendee
        })
        const attendance = {
          id: seminarDivision,
          mail: true,
          report: questionnaires.filter(q => q.seminar_division_id === seminarDivision).every(q => q.report_send_flg === true),
          employees: attendees
        }
        switch (seminarDivision) {
        case 1 :
          attendance['seminar'] = this.$t('employee_seminar_info.atc')
          break
        case 2:
          attendance['seminar'] = this.$t('employee_seminar_info.dc')
          break
        case 3:
          attendance['seminar'] = this.$t('employee_seminar_info.dac')
          break
        case 4:
          attendance['seminar'] = this.$t('employee_seminar_info.ppc')
          break
        }
        attendances.push(attendance)
      })
      this.setQuestionnaireData(this.tab)
      this.attendances = attendances
    },

    seminarDateRangeDisplay(startDate, endDate) {
      const start = new Date(startDate)
      const end = new Date(endDate)
      if (!endDate || start.toString() === end.toString()) {
        return startDate.replace(/-/g, '/')
      } else if (start.getMonth() === end.getMonth()) {
        return `${startDate.replace(/-/g, '/')} ~ ${end.getDate().toString().padStart(2, '0')}`
      } else {
        return `${startDate.replace(/-/g, '/')} ~ ${endDate.replace(/-/g, '/')}`
      }
    },
  }
}
</script>

<style scoped>

</style>
